<template>
  <div class="pages">
    <form class="page login">
      <h1>Errandite</h1>

      <ErranditeInput
        v-bind:data="user"
        field="email"
        type="text"
        icon="envelope"
        label="Email address"
      />
      <ErranditeInput
        v-show="register == true || signin == true"
        v-bind:data="user"
        field="password"
        type="password"
        icon="key"
        label="Password"
      />
      <button v-if="register == false && signin == false && cont == false" v-on:click="goContinue">
        <ErranditeIcon icon="check"/>
        <span>Continue</span>
      </button>
      <button v-if="register == true" v-on:click="goRegister">
        <ErranditeIcon icon="check"/>
        <span>Register</span>
      </button>
      <button v-if="signin == true" v-on:click="goSignIn">
        <ErranditeIcon icon="check"/>
        <span>Sign in</span>
      </button>
    </form>
  </div>
</template>

<script>
import ErranditeIcon from "./ErranditeIcon.vue";
import ErranditeInput from "./ErranditeInput.vue";

import { auth, persistence } from "./firebase";

export default {
  name: "ErranditeLogin",
  props: {
    state: Object,
    data: Object
  },
  data: function() {
    return {
      register: false,
      signin: false,
      cont: false,
      user: {
        email: "",
        password: ""
      }
    };
  },
  methods: {
    goContinue: function(ev) {
      var er = this;
      er.cont = true;
      ev.preventDefault();
      auth.fetchSignInMethodsForEmail(this.user.email).then(function(resp) {
        console.log(resp);
        if (resp.length > 0) {
          er.signin = true;
        } else {
          er.register = true;
        }
      });
    },
    goRegister: function(ev) {
      ev.preventDefault();
      var er = this;
      auth
        .setPersistence(persistence)
        .then(function() {
          auth
            .createUserWithEmailAndPassword(er.user.email, er.user.password)
            .catch(function(error) {
              // Handle Errors here.
              //var errorCode = error.code;
              //var errorMessage = error.message;
              console.log(error);

              // ...
            });
        })
        .catch(function(error) {
          // Handle Errors here.
          //var errorCode = error.code;
          //var errorMessage = error.message;
          console.log(error);
        });
    },
    goSignIn: function(ev) {
      ev.preventDefault();
      var er = this;
      auth
        .setPersistence(persistence)
        .then(function() {
          console.log(er.user);
          auth
            .signInWithEmailAndPassword(er.user.email, er.user.password)
            .catch(function(error) {
              // Handle Errors here.
              //var errorCode = error.code;
              //var errorMessage = error.message;
              console.log(error);
              // ...
            });
        })
        .catch(function(error) {
          // Handle Errors here.
          //var errorCode = error.code;
          //var errorMessage = error.message;
          console.log(error);
        });
    }
  },
  components: {
    ErranditeIcon,
    ErranditeInput
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../styles/_variables.scss";

.login {
  background-color: $dark;
  padding: $padding;
  box-sizing: border-box;

  button {
    padding: $padding;
    background-color: $highlight;
    border: 2px solid $highlight;
    border-radius: $borderRadius;
    color: $white;
    box-sizing: border-box;
    width: 100%;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;

    .icon {
      font-size: 24px;
      margin-right: $padding/2;
    }
  }
}
</style>
